import { AssetTypeModel } from "./asset-type.model";
import { FilterModel } from "./filter.model";
import { HistoryModel } from "./history.model";
import { RemedialModel } from "./remedial.model";
import { StockItemModel } from "./stock-item.model";

export class ClientModel {

  clientUid: number;
  clientName: string;
  assetGroups: Array<FilterModel> = [];
  jobTypes: Array<FilterModel> = [];
  userFilter: Array<FilterModel> = [];
  jobStatuses: Array<FilterModel> = [];
  organisations: Array<FilterModel> = [];
  allStockItems: Array<StockItemModel> = [];
  stlRemedialCodes: Array<RemedialModel> = [];
  alertCount: number;

  addressOne: string;
  addressTwo: string;
  addressCity: string;
  addressPostCode: string;

  organisationDefaultAssetTypes: Array<AssetTypeModel> = [];

  history: Array<HistoryModel> = [];

  constructor() 
  {
    
  }
}